export class Maintenance{

    constructor(date, user,patente,type,details,description ){
        this.user = user;
        this.patente = patente;
        this.type = type;
        this.details = details;
        this.description = description;
        this.date = date;
    }


}